/**
 * Event bus event name constants.
 * Use these constants instead of hardcoded strings when emitting or subscribing to events.
 */

export const EVENT_BUS_EVENTS = {
  /** Emitted when user logs out (manual or idle timeout) */
  LOGOUT: "logout",

  /** Emitted before auth redirects (403, session expiry) to disable navigation guards */
  FORCE_NAVIGATION: "force-navigation",

  /** Emitted when the selected school changes */
  SCHOOL_CHANGED: "school:changed",

  /** Emitted when Athena datasource mapping is updated */
  ATHENA_DATASOURCE_UPDATED: "athena-datasource-updated",

  /** Emitted to clear search input in map view */
  CLEAR_SEARCH: "clear-search",

  /** Emitted when list view selected IDs change */
  LISTVIEW_IDS_CHANGED: "listview-ids-changed",

  /** Emitted when a campus is selected in list view */
  LISTVIEW_CAMPUS_SELECTED: "listview-campus-selected",

  /** Emitted when a resource is selected in list view */
  LISTVIEW_RESOURCE_SELECTED: "listview-resource-selected",

  /** Emitted when map padding changes (overlay open/close) */
  MAP_PADDING_CHANGED: "map-padding-changed",

  /** Emitted when floor plan visibility is toggled via Shift+F */
  FLOOR_PLAN_VISIBILITY_CHANGED: "floor-plan-visibility-changed",
}
